import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import { selectFilter } from '../searchActions';
import { getInputValue } from '../searchViewState';
import { withRouter } from 'react-router-dom';
import { capitalizeFirstLetterOfEachWord } from '../../../utils/string';
import { historyShape } from '../../../utils/propTypes';
import './Filters.scss';

const filterTypes = ['all', 'transactions'];

export class _Filters extends Component {
    static propTypes = {
        history: historyShape,
        inputValue: PropTypes.string,
        match: PropTypes.shape({
            params: PropTypes.shape({
                filter: PropTypes.string
            })
        }),
        onCloseFilterDropDown: PropTypes.func,
        onSelectFilter: PropTypes.func
    };

    render() {
        return (
            <div className="emvio-search-filters">
                {filterTypes.map((filterType) => {
                    const filterTypeClassNames = classNames('search-filter', {
                        'selected-filter': isEqual(filterType, this.props.match.params.filter)
                    });

                    return (
                        <div className={filterTypeClassNames}
                            key={filterType}
                            onClick={this.props.onSelectFilter(this.props.history,
                                filterType,
                                this.props.inputValue,
                                this.props.onCloseFilterDropDown
                            )}>
                            <div className="upper-case-mobile">
                                {filterType.toUpperCase()}
                            </div>
                            <div className="camel-case-desktop">
                                {capitalizeFirstLetterOfEachWord(filterType)}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        inputValue: getInputValue(state)
    };
}

function mapDispatchToProps() {
    return {
        onSelectFilter: (history, filterType, query, closeFilterDropDown) => () => {
            selectFilter(history, filterType, query);
            if (closeFilterDropDown) {
                closeFilterDropDown();
            }
        }
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(_Filters));
